import { Link } from 'react-router-dom';
import { Download } from "lucide-react";
export default function Footer() {
  return <footer style={{
    backgroundColor: "rgb(16, 16, 18)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(244, 244, 243)",
    fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
    animation: "none 0s ease 0s 1 normal none running",
    borderTop: "1px solid rgba(255,255,255,0.09)"
  }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Geist:wght@400;500;600&family=Geist+Mono:wght@400;500&display=swap');
        .foot-link {
          color: rgb(185, 185, 189);
          font-family: 'Geist', 'Hanken Grotesk', system-ui, -apple-system, sans-serif;
          font-size: 14.88px;
          font-weight: 400;
          line-height: 23.808px;
          letter-spacing: -0.187px;
          border: 0px none rgb(185, 185, 189);
          text-decoration: none;
          transition: color 0.15s ease;
        }
        .foot-link:hover {
          color: #f5c518;
        }
      `}</style>

      <div className="page-container">
        <div style={{
        display: "grid",
        gridTemplateColumns: "1.4fr 1fr 1fr 1fr",
        gap: "32px",
        paddingBlock: "56px"
      }} className="grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="#" style={{
            textDecoration: "none",
            display: "inline-flex",
            alignItems: "center",
            gap: "6px"
          }}>
              <span style={{
              display: "flex",
              gap: "2px",
              alignItems: "center"
            }}>
                <span style={{
                width: "8px",
                height: "8px",
                backgroundColor: "#f5c518",
                display: "inline-block"
              }} />
                <span style={{
                width: "8px",
                height: "8px",
                backgroundColor: "#f5c518",
                display: "inline-block"
              }} />
                <span style={{
                width: "8px",
                height: "8px",
                backgroundColor: "#76767d",
                display: "inline-block"
              }} />
              </span>
              <span style={{
              color: "rgb(244, 244, 243)",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
              fontSize: "15px",
              fontWeight: "500",
              letterSpacing: "-0.01em"
            }}>
                ternative
              </span>
            </Link>
            <p style={{
            color: "rgb(118, 118, 125)",
            fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
            fontSize: "14.72px",
            fontWeight: "400",
            lineHeight: "23.552px",
            letterSpacing: "-0.187px",
            border: "0px none rgb(118, 118, 125)",
            animation: "none 0s ease 0s 1 normal none running",
            marginTop: "12px",
            marginBottom: "0"
          }}>
              Open-source AI for consumer hardware. Built in Colombia, licensed Apache 2.0.
            </p>
          </div>

          <div>
            <h5 style={{
            fontFamily: '"Geist Mono", "JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace',
            fontSize: "0.72rem",
            letterSpacing: "0.16em",
            textTransform: "uppercase",
            color: "rgb(118, 118, 125)",
            margin: "0px 0px 16px",
            fontWeight: "500"
          }}>
              PRODUCT
            </h5>
            <ul style={{
            listStyle: "none",
            margin: "0px",
            padding: "0px",
            display: "grid",
            gap: "10px"
          }}>
              <li style={{
              color: "rgb(244, 244, 243)",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
              fontSize: "17px",
              fontWeight: "400",
              lineHeight: "27.2px",
              letterSpacing: "-0.187px",
              border: "0px none rgb(244, 244, 243)",
              textAlign: "left",
              animation: "none 0s ease 0s 1 normal none running"
            }}>
                <Link to="#" className="foot-link">Orchid 1.0</Link>
              </li>
              <li style={{
              color: "rgb(244, 244, 243)",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
              fontSize: "17px",
              fontWeight: "400",
              lineHeight: "27.2px",
              letterSpacing: "-0.187px",
              border: "0px none rgb(244, 244, 243)",
              textAlign: "left",
              animation: "none 0s ease 0s 1 normal none running"
            }}>
                <Link to="#" className="foot-link">ternative engine</Link>
              </li>
              <li style={{
              color: "rgb(244, 244, 243)",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
              fontSize: "17px",
              fontWeight: "400",
              lineHeight: "27.2px",
              letterSpacing: "-0.187px",
              border: "0px none rgb(244, 244, 243)",
              textAlign: "left",
              animation: "none 0s ease 0s 1 normal none running"
            }}>
                <Link to="#" className="foot-link">Download</Link>
              </li>
            </ul>
          </div>

          <div>
            <h5 style={{
            fontFamily: '"Geist Mono", "JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace',
            fontSize: "0.72rem",
            letterSpacing: "0.16em",
            textTransform: "uppercase",
            color: "rgb(118, 118, 125)",
            margin: "0px 0px 16px",
            fontWeight: "500"
          }}>
              RESOURCES
            </h5>
            <ul style={{
            listStyle: "none",
            margin: "0px",
            padding: "0px",
            display: "grid",
            gap: "10px"
          }}>
              <li style={{
              color: "rgb(244, 244, 243)",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
              fontSize: "17px",
              fontWeight: "400",
              lineHeight: "27.2px",
              letterSpacing: "-0.187px",
              border: "0px none rgb(244, 244, 243)",
              textAlign: "left",
              animation: "none 0s ease 0s 1 normal none running"
            }}>
                <Link to="#" className="foot-link">Hugging Face ↗</Link>
              </li>
              <li style={{
              color: "rgb(244, 244, 243)",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
              fontSize: "17px",
              fontWeight: "400",
              lineHeight: "27.2px",
              letterSpacing: "-0.187px",
              border: "0px none rgb(244, 244, 243)",
              textAlign: "left",
              animation: "none 0s ease 0s 1 normal none running"
            }}>
                <Link to="#" className="foot-link">GitHub ↗</Link>
              </li>
              <li style={{
              color: "rgb(244, 244, 243)",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
              fontSize: "17px",
              fontWeight: "400",
              lineHeight: "27.2px",
              letterSpacing: "-0.187px",
              border: "0px none rgb(244, 244, 243)",
              textAlign: "left",
              animation: "none 0s ease 0s 1 normal none running"
            }}>
                <Link to="#" className="foot-link">Paper · Zenodo ↗</Link>
              </li>
            </ul>
          </div>

          <div>
            <h5 style={{
            fontFamily: '"Geist Mono", "JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace',
            fontSize: "0.72rem",
            letterSpacing: "0.16em",
            textTransform: "uppercase",
            color: "rgb(118, 118, 125)",
            margin: "0px 0px 16px",
            fontWeight: "500"
          }}>
              PROJECT
            </h5>
            <ul style={{
            listStyle: "none",
            margin: "0px",
            padding: "0px",
            display: "grid",
            gap: "10px"
          }}>
              <li style={{
              color: "rgb(244, 244, 243)",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
              fontSize: "17px",
              fontWeight: "400",
              lineHeight: "27.2px",
              letterSpacing: "-0.187px",
              border: "0px none rgb(244, 244, 243)",
              textAlign: "left",
              animation: "none 0s ease 0s 1 normal none running"
            }}>
                <Link to="#" className="foot-link">About</Link>
              </li>
              <li style={{
              color: "rgb(244, 244, 243)",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
              fontSize: "17px",
              fontWeight: "400",
              lineHeight: "27.2px",
              letterSpacing: "-0.187px",
              border: "0px none rgb(244, 244, 243)",
              textAlign: "left",
              animation: "none 0s ease 0s 1 normal none running"
            }}>
                <Link to="#" className="foot-link">Sponsor ↗</Link>
              </li>
              <li style={{
              color: "rgb(244, 244, 243)",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
              fontSize: "17px",
              fontWeight: "400",
              lineHeight: "27.2px",
              letterSpacing: "-0.187px",
              border: "0px none rgb(244, 244, 243)",
              textAlign: "left",
              animation: "none 0s ease 0s 1 normal none running"
            }}>
                <Link to="#" className="foot-link">License</Link>
              </li>
            </ul>
          </div>
        </div>

        <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "14px",
        justifyContent: "space-between",
        alignItems: "center",
        paddingBlock: "22px",
        borderTop: "1px solid rgba(255,255,255,0.09)",
        color: "rgb(118, 118, 125)",
        fontSize: "0.84rem",
        fontFamily: '"Geist Mono", "JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace'
      }}>
          <span>© 2026 Ternative · Apache-2.0</span>
          <span style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "6px"
        }}>
            <span>Hecho en Colombia</span>
            <span style={{
            display: "inline-flex",
            gap: "2px",
            alignItems: "center",
            marginLeft: "2px"
          }}>
              <span style={{
              width: "8px",
              height: "8px",
              backgroundColor: "#f5c518",
              display: "inline-block"
            }} />
              <span style={{
              width: "8px",
              height: "8px",
              backgroundColor: "#1f55b0",
              display: "inline-block"
            }} />
              <span style={{
              width: "8px",
              height: "8px",
              backgroundColor: "#d8242c",
              display: "inline-block"
            }} />
            </span>
          </span>
        </div>
      </div>
    </footer>;
}